/** @jsx jsx */
import { any } from 'prop-types'
import { jsx, Flex, Text, Link } from 'theme-ui'

const ContactSection = ({ contacts }) => {
  return (
    <Flex
      sx={{
        width: ['100%', '40%', '50%', '100%'],
        flexDirection: ['column', 'column', 'column', 'row'],
        mt: [6, 0],
      }}
    >
      {contacts &&
        contacts.map(
          ({
            id,
            location,
            address1,
            address2,
            tollFreeNumber,
            phoneNumber,
            faxNumber,
          }) => (
            <Flex
              sx={{
                flexDirection: 'column',
                ml: [0, 0, 'auto'],
                width: ['100%', '100%', '60%', 'auto'],
                ':last-child': {
                  mr: 0,
                  ml: [null, null, null, 30],
                  mt: [3, 4, 4, 0],
                },
              }}
              key={id}
            >
              <Text variant="xSmallText" sx={{ color: 'white' }}>
                {location}
              </Text>
              <Link
                href={`https://www.google.com/maps/search/?api=1&query=${address1}+${address2}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Text variant="xSmallText" sx={{ color: 'white' }}>
                  {address1}
                </Text>
                <Text variant="xSmallText" sx={{ color: 'white' }}>
                  {address2}
                </Text>
              </Link>
              <Flex>
                <Text variant="xSmallText" sx={{ color: 'muted', mr: 1 }}>
                  Toll Free
                </Text>
                <Link href={`tel:${tollFreeNumber}`}>
                  <Text variant="xSmallText" sx={{ color: 'white' }}>
                    {tollFreeNumber}
                  </Text>
                </Link>
              </Flex>
              <Flex>
                <Text variant="xSmallText" sx={{ color: 'muted', mr: 1 }}>
                  Phone
                </Text>
                <Link href={`tel:${phoneNumber}`}>
                  <Text variant="xSmallText" sx={{ color: 'white' }}>
                    {phoneNumber}
                  </Text>
                </Link>
              </Flex>
              <Flex>
                <Text variant="xSmallText" sx={{ color: 'muted', mr: 1 }}>
                  Fax
                </Text>
                <Text variant="xSmallText" sx={{ color: 'white' }}>
                  {faxNumber}
                </Text>
              </Flex>
            </Flex>
          )
        )}
    </Flex>
  )
}

ContactSection.propTypes = {
  contacts: any,
}
export default ContactSection
